import React from "react";
import Select from "react-select";
import { reactSelectTheme } from "../ui";

// Was a fourth-of-three private copy of the app's react-select styles, hardcoding
// #3b82f6 for the focused border, the focus ring and the selected option. Shared and
// tokenised in Phase 5 (2026-08-24). The 38px control and 1px ring were this file's
// own choices and are kept as arguments.
const themeStyles = reactSelectTheme({ minHeight: 38, ring: 1 });


const TagSelector = ({
  options = [],
  value = [],
  onChange,
  placeholder = "Select...",
  label = "",
  isMulti = true,
  id = "",
}) => {
  const selectOptions = options.map((opt) =>
    typeof opt === "string" ? { value: opt, label: opt } : opt
  );
  const selectValue = value.map((v) =>
    typeof v === "string" ? { value: v, label: v } : v
  );

  return (
    <div className="mb-2">
      {label && <label className="form-label">{label}</label>}
      <Select
        id={id}
        isMulti={isMulti}
        options={selectOptions}
        value={selectValue}
        onChange={(selected) => onChange((selected || []).map((s) => s.value))}
        placeholder={placeholder}
        classNamePrefix="react-select"
        styles={themeStyles}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        menuPosition="fixed"
      />
    </div>
  );
};

export default TagSelector;
